module.exports = __webpack_public_path__ + "static/media/logoorange.acaaa640.png";